module.exports = __webpack_public_path__ + "assets/img/enterIcon1.6cb8629c.png";